import moment from "moment"

export function isButtonDisabled(created_at) {
    const currentDate = moment().startOf('month')
    const fiveDaysPrior = currentDate.clone().subtract(5, 'days')
    const createdAtDate = moment(created_at)
    const isWithinFiveDaysPrior = createdAtDate.isSameOrAfter(fiveDaysPrior, 'day')
    return !isWithinFiveDaysPrior
}


export function getBgClassByAmount(amount) {
    if (amount < 100) {
        return 'rgba(40, 167, 69, 0.64)'
    } else if (amount >= 100 && amount < 200) {
        return 'rgba(255, 193, 7, 0.64)'
    } else if (amount >= 200 && amount < 300) {
        return 'rgba(23, 162, 184, 0.64)'
    } else {
        return 'rgba(220, 53, 69, 0.64)'
    }
}

export const calculateExpenseByEachUser = (expenses) => {
    const expenseByUser = expenses.reduce((acc, expense) => {
        const { user } = expense
        if (acc[user.id]) {
            acc[user.id].push(expense)
        } else {
            acc[user.id] = [expense]
        }
        return acc
    }, {})

    const expenseByUserArray = Object.keys(expenseByUser).map((key) => {
        const expenseArray = expenseByUser[key]
        const total = expenseArray.reduce((total, expense) => total + expense.amount, 0)
        return {
            user: expenseArray[0].user,
            total,
        }
    })

    return expenseByUserArray
}
